import script from "./SellerLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./SellerLayout.vue?vue&type=script&setup=true&lang=js"

import "./SellerLayout.vue?vue&type=style&index=0&id=161c1fcc&lang=css"

const __exports__ = script;

export default __exports__